module.exports = __webpack_public_path__ + "static/img/icon.7dd7a1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_3/icon.jpg
// module id = 2ddo
// module chunks = 0